import React from 'react';
import { CheckCircleOutline } from '@mui/icons-material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { DocumentListItemRow } from './DocumentListItemRow';


export const CollaborativeAgreementSignedListItem: React.VFC<{
  document: CollaborativeAgreementSigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const signedOn = CalendarDateService.date(document.signedAt).format(DateFormats['MMM D, YYYY']);

  return (
    <DocumentListItemRow
      name={template.name}
      status={document.counterSignedAt ? `Active · signed ${signedOn}` : 'Awaiting counter-signature'}
      statusColor="success"
      icon={<CheckCircleOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
